import api from "./api";

export const getFunnelOpportunityNotes = (opportunityId, contactId) => {
    if (opportunityId) {
        return api.get(`/funnel-opportunities/${opportunityId}/notes`);
    }
    // Rota nova para contactId
    return api.get(`/contact-notes?contactId=${contactId}`);
};

export const createFunnelOpportunityNote = (opportunityId, note, contactId) => {
    if (opportunityId) {
        return api.post(`/funnel-opportunities/${opportunityId}/notes`, { note });
    }
    // Rota nova para contactId
    return api.post(`/contact-notes`, { note, contactId });
};
